import { css } from 'styled-components';

// TODO: `border-box` should be global.
const borderBox = css`
    box-sizing: border-box;

    *,
    *::after,
    *::before {
        box-sizing: inherit;
    }
`;

const button = css`
    margin: 0;
    padding: 0;
    font-family: inherit;
    line-height: 1;
    color: inherit;
    overflow: visible;
    text-transform: none;
    appearance: button;
    cursor: pointer;
    outline: none !important;
    background: none;
    border: none;
    border-radius: 0;

    &[disabled] {
        cursor: default;
    }

    &::-moz-focus-inner {
        padding: 0;
        border-style: none;
    }

    &:-moz-focusring {
        outline: 1px dotted ButtonText;
    }

    &:focus {
        box-shadow: none;
    }
`;

const hr = css`
    // Required specificity to compact global reset.
    height: 0 !important;
    margin: 0;
    color: white;
    background: unset;
    border-top: 1px solid currentColor;
`;

const input = css`
    // Ideally, we simply "unset" everything.
    // all: unset;

    margin: 0;
    padding: 0;
    width: auto;
    height: auto;
    font-family: inherit;
    line-height: 1;
    color: white;
    background: none;
    outline: none;
    box-shadow: none;
    border: none;
    border-radius: 0;

    &::placeholder {
        color: currentColor;
        box-shadow: none;
        opacity: 0.6;
        text-overflow: ellipsis;
    }

    &:focus {
        box-shadow: none;
    }
`;

const inputNumberSubset = css`
    &,
    &::-webkit-outer-spin-button,
    &::-webkit-inner-spin-button {
        -webkit-appearance: none;
        -moz-appearance: textfield;
    }
`;

const inputNumber = css`
    ${input};
    ${inputNumberSubset};
`;

const inputRangeSubset = css`
    appearance: none;
    cursor: pointer;
    width: 100%;

    &::-webkit-slider-thumb {
        appearance: none;
        box-shadow: none;
    }

    &::-moz-range-thumb {
        border: none;
        border-radius: 0;
        box-shadow: none;
    }
`;

const inputRange = css`
    ${input};
    ${inputRangeSubset};
`;

const inputSearchSubset = css`
    &::-ms-clear {
        display: none;
        width: 0;
        height: 0;
    }

    &::-ms-reveal {
        display: none;
        width: 0;
        height: 0;
    }

    &::-webkit-search-decoration,
    &::-webkit-search-cancel-button,
    &::-webkit-search-results-button,
    &::-webkit-search-results-decoration {
        display: none;
    }
`;

const inputSearch = css`
    ${input};
    ${inputSearchSubset};
`;

const link = css`
    outline: none !important;
    text-decoration: none;
`;

const list = css`
    margin: 0;
    padding: 0;
    list-style: none;
`;

const table = css`
    min-width: 100%;
    border-collapse: collapse;
    border-spacing: 0;
`;

const tableCell = css`
    padding: 0;
    line-height: 1;
`;

const typography = css`
    margin: 0;
    padding: 0;
    font-size: unset;
    font-weight: 400;
    font-style: normal;
    line-height: 1;
`;

export const styledReset = {
    borderBox,
    button,
    hr,
    input,
    inputNumberSubset,
    inputNumber,
    inputRange,
    inputSearchSubset,
    inputSearch,
    link,
    list,
    table,
    tableCell,
    typography,
};
